import { ArrowRight, PartyPopper } from 'lucide-react'
import React from 'react'
import { toast } from 'sonner'

import { Banner, Button } from 'slab'
import {
  type PostEmployersEmployersToggleBillingV2OptInMutationResult,
  usePostEmployersEmployersToggleBillingV2OptIn,
} from 'utils/web_api'

interface BillingV2OptInBannerProps {
  enableBillingV2: boolean;
  billingV2OptIn: boolean;
}

export function BillingV2OptInBanner ({
  enableBillingV2,
  billingV2OptIn: initialOptIn,
}: BillingV2OptInBannerProps) {
  const [optedIn, setOptedIn] = React.useState(initialOptIn)

  const mutation = usePostEmployersEmployersToggleBillingV2OptIn({
    mutation: {
      onSuccess: (data: PostEmployersEmployersToggleBillingV2OptInMutationResult) => {
        setOptedIn(data.opted_in)
        const message = data.opted_in
          ? 'Opted in to the new billing experience'
          : 'Reverted to the old billing experience'
        toast.success(message)
        window.segment?.track(
          data.opted_in
            ? '[ER] BillingV2: opted in'
            : '[ER] BillingV2: opted out'
        )
      },
      onError: (error: unknown) => {
        const errorMessage =
          error instanceof Error
            ? error.message
            : 'Failed to update billing experience preference'
        toast.error(errorMessage)
      },
    },
  })

  if (!enableBillingV2) {
    return null
  }

  return (
    <div className='mb-6'>
      <Banner
        type='notice'
        title={
          optedIn
            ? "You're currently viewing our new billing experience! You can go back to the old experience any time."
            : "Our new billing experience is available to use! We've revamped the experience to make billing easier to understand."
        }
        icon={PartyPopper}
        cta={
          <Button
            onClick={() => mutation.mutate()}
            disabled={mutation.isPending}
            variant='secondary'
          >
            {optedIn
              ? (
                  'Go back to the old experience'
                )
              : (
                <span className='flex items-center gap-2'>
                  <span>Try it out</span> <ArrowRight size={16} />
                </span>
                )}
          </Button>
        }
      />
    </div>
  )
}
